import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col bg-white px-2" }
const _hoisted_2 = {
  key: 0,
  class: "flex mt-5 justify-center"
}
const _hoisted_3 = { class: "flex flex-col gap-[5px] pt-3 mt-3" }
const _hoisted_4 = { class: "flex w-full pt-16" }
const _hoisted_5 = { class: "text-sm text-gray-400" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_title = _resolveComponent("app-title")!
  const _component_db_input = _resolveComponent("db-input")!
  const _component_DbPasswordInput = _resolveComponent("DbPasswordInput")!
  const _component_db_button = _resolveComponent("db-button")!
  const _component_db_form = _resolveComponent("db-form")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.title != 'production')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_app_title, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.title), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_db_form, { class: "flex flex-col gap-[5px]" }, {
        default: _withCtx(() => [
          _createVNode(_component_db_input, {
            variant: "outline",
            placeholder: _ctx.$t('login.username') + '*',
            label: _ctx.$t('login.username') + '*',
            name: "username",
            ariainvalid: _ctx.errors.username ? 'true' : '',
            modelValue: _ctx.user.username,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.username) = $event))
          }, null, 8, ["placeholder", "label", "ariainvalid", "modelValue"]),
          _createVNode(_component_DbPasswordInput, {
            modelValue: _ctx.user.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.password) = $event)),
            placeholder: _ctx.$t('login.password') + '*',
            label: _ctx.$t('login.password') + '*',
            ariainvalid: _ctx.errors.username ? 'true' : '',
            variant: "outline",
            name: "password"
          }, null, 8, ["modelValue", "placeholder", "label", "ariainvalid"]),
          _createElementVNode("p", {
            class: _normalizeClass(
            _ctx.errors.username == true && _ctx.errors.password == true
              ? 'flex text-red-700 justify-center mt-2 text-sm'
              : 'hidden'
          )
          }, _toDisplayString(_ctx.$t("login.error")), 3),
          _createVNode(_component_db_button, {
            id: "login",
            variant: "brand-primary",
            "class-list": "w-full mt-2",
            onClick: _ctx.login
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("login.login")), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        class: "w-full",
        to: "/reset-password-guest"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_db_button, {
            variant: "tertiary-plain",
            "class-list": "w-full"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("landing.login.reset_password")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("landing.required_field")), 1)
      ])
    ])
  ]))
}